import { render, staticRenderFns } from "./backdrop-loader.vue?vue&type=template&id=c0f5eacc&scoped=true"
import script from "./backdrop-loader.vue?vue&type=script&lang=js"
export * from "./backdrop-loader.vue?vue&type=script&lang=js"
import style0 from "./backdrop-loader.vue?vue&type=style&index=0&id=c0f5eacc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f5eacc",
  null
  
)

export default component.exports